/**
 * SVG CockroachDB icon
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const propTypes = {
  classes: PropTypes.shape({
    circleStyle: PropTypes.string.isRequired,
    cockroachStyle: PropTypes.string.isRequired,
  }).isRequired,
};

export function UnstyledCockroachDBIcon({ ...props }) {
  const { classes, ...additionalProps } = props;
  const { circleStyle, cockroachStyle } = classes;
  return (
    <SvgIcon viewBox="0 0 120 120" {...additionalProps}>
      <g>
        <circle className={circleStyle} cx="60" cy="60" r="55.5" />
        <path
          className={cockroachStyle}
          d="M92.1,32.4c-3.3-0.9-6.6-1.3-10-1.3c-7.8,0-15.5,2.3-22,6.6c-6.5-4.3-14.1-6.7-22-6.6c-3.4,0-6.8,0.4-10.1,1.3
          c-1.4,0.3-2.7,0.8-4.1,1.3c0,0.1,0,0.1,0,0.2c0.6,1.2,1.2,2.4,1.9,3.6c0.1,0,0.1,0,0.2,0c1.3-0.5,2.7-0.9,4.1-1.2
          c9-2,18.4-0.5,26.3,4.3c-3.4,2.9-6.3,6.3-8.6,10.2c-0.5,0.7-0.8,1.5-1.2,2.3c-0.4,0.8-0.5,1-0.7,1.6c-0.2,0.5-0.7,1.6-1,2.4
          c-5.5,14.8-1.7,31.5,9.7,42.4c0.6,0.6,1.2,1.1,1.8,1.7c0.6,0.5,1,0.8,1.5,1.2s1.3,1,2,1.5c0.1,0,0.1,0,0.2,0c0.7-0.5,1.4-1,2-1.5
          c0.7-0.5,1-0.8,1.5-1.2c0.5-0.4,1.2-1.1,1.8-1.7c7.8-7.5,12.2-17.8,12.2-28.6c0-4.7-0.8-9.4-2.5-13.8c-0.3-0.8-0.7-1.7-1-2.5
          c-0.4-0.8-0.5-1.1-0.7-1.6c-0.2-0.5-0.8-1.5-1.2-2.3c-2.3-3.8-5.2-7.3-8.6-10.2c7.9-4.8,17.3-6.3,26.3-4.2c1.4,0.3,2.8,0.7,4.1,1.2
          c0.1,0,0.1,0,0.2,0c0.7-1.1,1.3-2.3,1.9-3.5c0-0.1,0-0.1,0-0.2C94.9,33.3,93.5,32.8,92.1,32.4z"
        />
      </g>
    </SvgIcon>
  );
}

UnstyledCockroachDBIcon.propTypes = propTypes;

const styles = (theme) => ({
  circleStyle: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: theme.customColors.white,
    stroke: theme.customColors.teal,
    strokeWidth: 7,
  },
  cockroachStyle: {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    fill: theme.customColors.teal,
  },
});

export default withStyles(styles)(UnstyledCockroachDBIcon);
